import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'

const classIcons = 'cell-icons cursor-pointer'

function RevenueStationaryTableHeader({ className, onFilter, sortBy, type }) {
  const { t: translate } = useTranslation()
  const nameValue = type === 'group' ? REVENUE_SORT_COLUMNS.CHANNEL_STORE_NAME : REVENUE_SORT_COLUMNS.STORE_NAME

  return (
    <Box className={classNames('revenue-stationary-table-header', className)}>
      <Box className={classNames('row-wrapper flex-row', sortBy.order)}>
        <Box
          aria-label="title"
          className={classNames('cell-title flex-row cursor-pointer', {
            'is-active': sortBy.value === nameValue,
          })}
          data-value={nameValue}
          onClick={onFilter}
          role="columnheader"
        >
          <Box display="inline" className="category mobile-only" data-value={nameValue} onClick={onFilter} />

          <Box data-value={nameValue} onClick={onFilter}>
            {translate('revenue.store')}
          </Box>
        </Box>

        <Box
          aria-label="revenue"
          className={classNames('cell-value cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN,
          })}
          data-value={REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN}
          onClick={onFilter}
          role="columnheader"
        >
          <Box display="inline" data-value={REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN} onClick={onFilter}>
            {translate('revenue.revenue')}
          </Box>
        </Box>

        <Box
          className={classNames('tablet-portrait-up-only', 'cell-category cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.CLUSTER,
          })}
          data-value={REVENUE_SORT_COLUMNS.CLUSTER}
          onClick={onFilter}
        >
          <Box display="inline" className="category" data-value={REVENUE_SORT_COLUMNS.CLUSTER} onClick={onFilter}>
            {translate('revenue.table.category')}
          </Box>
        </Box>

        <Box
          className={classNames('cell-concept cursor-pointer', { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.CONCEPT })}
          data-value={REVENUE_SORT_COLUMNS.CONCEPT}
          onClick={onFilter}
        >
          <Box display="inline" data-value={REVENUE_SORT_COLUMNS.CONCEPT} onClick={onFilter}>
            {translate('revenue.table.concept')}
          </Box>
        </Box>

        <Box
          className={classNames('cell-difference cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.DIFFERENCE,
          })}
          data-value={REVENUE_SORT_COLUMNS.DIFFERENCE}
          onClick={onFilter}
        >
          %
        </Box>

        <Box
          className={classNames(classIcons, { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.ESIZE })}
          data-value={REVENUE_SORT_COLUMNS.ESIZE}
          onClick={onFilter}
        >
          <Box className="fm fm-esize" onClick={onFilter} data-value={REVENUE_SORT_COLUMNS.ESIZE} />
        </Box>

        <Box
          className={classNames('cell-icons cell-surfchange cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.SPACE_CHANGE,
          })}
          data-value={REVENUE_SORT_COLUMNS.SPACE_CHANGE}
          onClick={onFilter}
        >
          <Box className="fm fm-surfchange-up" onClick={onFilter} data-value={REVENUE_SORT_COLUMNS.SPACE_CHANGE} />
        </Box>

        <Box
          className={classNames(classIcons, { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.CHANGED_COMPARED })}
          data-value={REVENUE_SORT_COLUMNS.CHANGED_COMPARED}
          onClick={onFilter}
        >
          <Box className="fm fm-header-table" onClick={onFilter} data-value={REVENUE_SORT_COLUMNS.CHANGED_COMPARED} />
        </Box>

        <Box
          className={classNames(classIcons, { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.PROMOTION })}
          data-value={REVENUE_SORT_COLUMNS.PROMOTION}
          onClick={onFilter}
        >
          <Box className="fm fm-promotions" onClick={onFilter} data-value={REVENUE_SORT_COLUMNS.PROMOTION} />
        </Box>

        <Box
          className={classNames(classIcons, { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.FAIR })}
          data-value={REVENUE_SORT_COLUMNS.FAIR}
          onClick={onFilter}
        >
          {translate('revenue.fair')[0]}
        </Box>

        <Box
          className={classNames(classIcons, { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.EXPRESS })}
          data-value={REVENUE_SORT_COLUMNS.EXPRESS}
          onClick={onFilter}
        >
          <Box className="fm fm-ccc-express" onClick={onFilter} data-value={REVENUE_SORT_COLUMNS.EXPRESS} />
        </Box>
      </Box>
    </Box>
  )
}

RevenueStationaryTableHeader.propTypes = {
  className: PropTypes.string,
  onFilter: PropTypes.func,
  sortBy: PropTypes.object,
  type: PropTypes.string,
}

export default RevenueStationaryTableHeader
